import React, {Component} from 'react';
import User from './User';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';


class Users extends Component{
    state ={users:[]}
    componentDidMount(){

      fetch(process.env.REACT_APP_PROXY_HOST+'/liste/users')
      .then(res=>res.json())
      .then(users=>this.setState({users}));
        }

    render(){
        return (
        <div>
        <h1>Utilisateurs</h1>
        <List component="nav" aria-label="secondary mailbox folders">
                  {this.state.users.map(user=>
                   <ListItem button>
                     <ListItemText primary={user.id} />
                    <User id={user.id} username={user.username}/>
                  </ListItem>
                  )
                  }
        </List>       
        </div>);
    }
}


export default Users;


// WEBPACK FOOTER //
// src/components/Users.js